import React from 'react';
import { Subject, Progress } from '../types';

interface DashboardProps {
  selectedForm: number | null;
  subjects: Subject[];
  progress: Progress[];
  loadTopics: (subject: Subject) => void;
  getProgressForSubject: (subjectName: string) => Progress | undefined;
  getScoreColor: (score: number) => string;
}

export const Dashboard: React.FC<DashboardProps> = ({ 
  selectedForm, 
  subjects, 
  progress, 
  loadTopics, 
  getProgressForSubject, 
  getScoreColor 
}) => {
  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <h1 style={{ fontSize: 'clamp(24px, 5vw, 32px)', marginBottom: '12px' }}>
          Welcome to Zambia Smart Learning
        </h1>
        <p style={{ color: '#6b7280' }}>AI-powered learning aligned with Zambia's Competence-Based Curriculum</p>
        <div style={{ 
          display: 'inline-block', 
          background: '#f0fdf4', 
          padding: '8px 16px', 
          borderRadius: '20px', 
          marginTop: '12px' 
        }}>
          <span style={{ color: '#15803d', fontWeight: '500' }}>🎓 Form {selectedForm} Student</span>
        </div>
      </div>
      
      {/* Subjects Grid */}
      <div style={{ marginBottom: '32px' }}>
        <h3 style={{ marginBottom: '20px', fontSize: '18px' }}>📖 Available Subjects</h3>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', 
          gap: '16px'
        }}>
          {subjects.map(subject => {
            const progressData = getProgressForSubject(subject.name);
            return (
              <button
                key={subject.id}
                onClick={() => loadTopics(subject)}
                style={{
                  background: 'white',
                  borderRadius: '16px',
                  padding: '24px 16px',
                  textAlign: 'center',
                  border: '1px solid #e5e7eb',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '12px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = subject.color;
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.05)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#e5e7eb';
                  e.currentTarget.style.transform = 'none';
                  e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.05)';
                }}
              >
                <div style={{ 
                  width: '64px', 
                  height: '64px', 
                  borderRadius: '16px', 
                  background: '#f3f4f6',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '32px'
                }}>
                  {subject.icon}
                </div>
                <div>
                  <h4 style={{ fontSize: '16px', margin: '0 0 4px 0', color: '#1f2937' }}>{subject.name}</h4>
                  {progressData ? (
                    <span style={{ fontSize: '12px', color: getScoreColor(progressData.mastery_score), fontWeight: '600' }}>
                      {Math.round(progressData.mastery_score)}% Mastery
                    </span>
                  ) : (
                    <span style={{ fontSize: '12px', color: '#9ca3af' }}>Not started</span>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
